<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast></Toast>
                <h5>{{ $t('menu.lottoRestrictions') }}</h5>
                <Fieldset :legend="$t('lotto.addNewRestriction')" :toggleable="true" :collapsed="true">
                    <div class="p-grid">
                        <div class="p-col-12 p-grid">
                            <label for="displayName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.lotteryName') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <Dropdown style="width: 100%" v-model="newRuleLotteryModel" :options="lotteries" optionLabel="name" :placeholder="$t('dropdown.placeholder.lottery')" :filter="!this.isMobile()" />
                            </div>
                        </div>
                        <div class="p-col-12 p-grid">
                            <label for="displayName" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.draw') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <Dropdown style="width: 100%" v-model="newRuleDrawModel" :options="lotteryDraws" optionLabel="name" :placeholder="$t('lotto.drawType')" :filter="!this.isMobile()" />
                            </div>
                        </div>
                        <div class="p-col-12 p-grid">
                            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.numbers') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <InputText style="width: 100%" type="text" v-model="numbers" />
                            </div>
                        </div>
                        <div class="p-col-12 p-grid">
                            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.acceptCombo') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <InputSwitch v-model="newRule.AcceptCombo" />
                            </div>
                        </div>
                        <div class="p-col-12 p-grid">
                            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.maxTicketsNo') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <InputText style="width: 100%" type="text" v-model="newRule.MaxTicketsNo" />
                            </div>
                        </div>
                        <div class="p-col-12 p-grid">
                            <label class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">{{ $t('lotto.rules.maxTicketsAmount') }} *</label>
                            <div class="p-col-12 p-md-4">
                                <InputText style="width: 100%" type="text" v-model="newRule.MaxTicketsAmount" />
                            </div>
                        </div>
                        <div class="p-col-12">
                            <p>{{ $t('forms.mandatoryFieldsText') }}</p>
                        </div>
                        <div class="p-col-12 p-md-4">
                            <Button @click="addNewRestriction()" :label="$t('buttons.save')" class="p-button-raised p-button-success p-mr-2 p-mb-2" />
                        </div>
                        <transition-group name="p-message" tag="div">
                            <Message :key="errorKeyCount + 1" :severity="'error'" v-show="showError">{{ errorText }}</Message>
                        </transition-group>
                    </div>
                </Fieldset>
                <DataTable :value="items" v-model:expandedRows="expandedRows" :loading="loading" class="p-mt-3" ref="datatable" responsiveLayout="scroll" stateStorage="session" stateKey="dt-state-popularLeagues">
                    <Column
                        ><template #body="slotProps">
                            <span class="indexColumn">{{ slotProps.index + 1 }}</span>
                        </template>
                    </Column>
                    <Column :expander="true" headerStyle="width: 3rem"></Column>
                    <Column :header="$t('lotto.lottery')">
                        <template #body="slotProps"> {{ lotteriesDictionary[slotProps.data.lotteryId] }}</template></Column
                    >
                    <Column field="drawDisplayName" :header="$t('lotto.rules.lottoDisplayName')"></Column>
                    <Column field="acceptCombo" :header="$t('lotto.rules.acceptCombo')">
                        <template #body="slotProps">
                            <Button v-if="slotProps.data.acceptCombo == false" icon="pi pi-times" class="p-button-text p-button-danger p-mr-2" />
                            <Button v-else icon="pi pi-check" class="p-button-text p-button-success p-mr-2" /> </template
                    ></Column>

                    <Column field="restrictedNumbers" :header="$t('lotto.rules.numbers')"></Column>
                    <Column field="maxTicketsNo" :header="$t('lotto.rules.maxTicketsNo')"></Column>
                    <Column field="maxTicketsAmount" :header="$t('lotto.rules.maxTicketsAmount')"></Column>

                    <Column :exportable="false" class="p-text-right">
                        <template #body="slotProps">
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-mr-2" @click="removeRule(slotProps.data._id)" />
                        </template>
                    </Column>
                    <template #expansion="slotProps">
                        <RuleExtension :rule="slotProps.data"></RuleExtension>
                    </template>
                </DataTable>
            </div>
        </div>
    </div>
</template>
<script>
import { LottoApi } from '../../service/LottoApi';
import { BoLottoApi } from '../../service/BoLottoApi';
import { uiSettings } from '../../settings/uiSettings';
import RuleExtension from './Components/RuleExtension.vue';
export default {
    components: {
        RuleExtension,
    },
    data() {
        return {
            tableHeight: uiSettings.tableHeight,
            items: [],
            LottoApi: new LottoApi(),
            BoLottoApi: new BoLottoApi(),
            loading: true,
            crtRoute: 'lottoRestrictions',
            errorKeyCount: 0,
            expandedRows: [],
            numbers: '',
            newRule: {
                RestrictedNumbers: [],
                AcceptCombo: false,
                MaxTicketsNo: 0,
                MaxTicketsAmount: 0,
            },
            showError: false,
            errorText: '',
            lotteries: [],
            lotteryModel: { name: 'All', id: 0, code: 0 },
            newRuleLotteryModel: {},
            newRuleDrawModel: { name: 'all', _id: 'all', code: 0 },
            lotteryDraws: [],
            lotteriesDictionary: [],
        };
    },
    computed: {},
    mounted() {
        this.getLotteries();
    },
    watch: {
        newRuleLotteryModel() {
            this.getLotteryDraws();
        },
    },
    methods: {
        getLotteries() {
            this.LottoApi.getLotteriesForFilter()
                .then(response => {
                    this.lotteries = response.data;
                    this.createLotteriesDictionary();
                    this.getLottoRestrictions();
                })
                .catch(() => {
                    this.showToast('error', this.$t('alerts.generalError'));
                });
        },
        getLotteryDraws() {
            this.LottoApi.getLotteryDraws(this.newRuleLotteryModel.id)
                .then(response => {
                    this.lotteryDraws = response.data;
                    this.lotteryDraws.forEach(draw => {
                        draw.name = draw.offerNumber + ' : ' + this.formatDate(draw.date);
                    });
                })
                .catch(() => {
                    this.showToast('error', this.$t('alerts.generalError'));
                });
        },
        getLottoRestrictions() {
            this.LottoApi.getLottoRestrictions().then(response => {
                this.items = response.data;
                this.loading = false;
            });
        },
        removeRule(ruleId) {
            this.BoLottoApi.removeRestrictionRule(ruleId)
                .then(() => {
                    this.getLottoRestrictions();
                })
                .catch(() => {});
        },
        addNewRestriction() {
            if (this.notNullOrEmptyField(this.numbers) && this.notNullOrEmptyField(this.newRuleLotteryModel.id)) {
                this.newRule.DrawId = this.newRuleDrawModel._id;
                this.newRule.LotteryId = this.newRuleLotteryModel.id;
                this.newRule.DrawDisplayName = this.newRuleDrawModel.name;
                try {
                    this.newRule.RestrictedNumbers = this.numbers.split(',').map(Number);
                } catch {
                    this.errorText = this.$t('lotto.rules.incorectNumbersFormat');
                    this.showError = true;
                    this.disableSubmit = false;
                    this.errorKeyCount++;
                }
                console.log(this.newRule);
                this.BoLottoApi.addNewRestrictionRule(this.newRule).then(() => {
                    this.newRule.RestrictedNumbers = [];
                    this.newRule.MaxTicketsAmount = 0;
                    this.newRule.MaxTicketsNo = 0;
                    this.numbers = [];
                    this.newRule.AcceptCombo = false;
                    this.newRuleDrawModel = { name: 'all', _id: 'all', code: 0 };
                    this.newRuleLotteryModel = {};
                    this.getLottoRestrictions();
                });
            } else {
                this.errorText = this.$t('forms.mandatoryFieldsMessage');
                this.showError = true;
                this.disableSubmit = false;
                this.errorKeyCount++;
            }
        },
        createLotteriesDictionary() {
            for (let i = 0; i < this.lotteries.length; i++) {
                this.lotteriesDictionary[this.lotteries[i].id] = this.lotteries[i].name;
            }
        },
    },
};
</script>
